import { useTranslation } from "react-i18next";
import "./application_tracking_widget.scss";
import { useEffect, useState } from "react";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";
import { Button } from "./button";
import { Body } from "./typography";
import ApplicationStages from "./application_stages";
import { SnowplowEvent, useSnowplowTracker } from "~/hooks/use_snowplow_tracker";
import serverAssetUrl from "~/utils/asset_url.server";
import { serverOnly$ } from "vite-env-only/macros";

const ApplicationTrackingWidget = () => {
  const { t } = useTranslation("job_post");
  const [jobSeekersUrl, setJobSeekersUrl] = useState("");
  const { preview_mode, button_shape } = useBoardConfiguration();
  const { trackEvent } = useSnowplowTracker();
  const assetUrl = serverOnly$(serverAssetUrl) || window.ENV.ASSET_URL;

  useEffect(() => {
    !preview_mode &&
      trackEvent(SnowplowEvent.MyGreenhouseAdShown, {
        type: "track_your_status",
      });
  });

  useEffect(() => {
    setJobSeekersUrl(`${window.ENV.JOB_SEEKERS_URL}/users/sign_in?source=track_your_status`);
  }, []);

  const trackClick = () => {
    !preview_mode &&
      trackEvent(SnowplowEvent.MyGreenhouseAdClicked, {
        type: "track_your_status",
      });
  };

  return (
    <div className="application_tracking_widget">
      <div className="application_tracking_widget__icon">
        <img src={`${assetUrl}/greenhouse_white_g.svg`} alt="MyGreenhouse Application Tracking" />
      </div>
      <div className="application_tracking_widget__content">
        <div className="application_tracking_widget__content__header">
          <Body medium>{t("application_tracking_widget.header")}</Body>
          <Body>{t("application_tracking_widget.body")}</Body>
        </div>
        <ApplicationStages />
        <Button
          secondary
          link
          href={preview_mode ? undefined : jobSeekersUrl}
          target="_blank"
          shape={button_shape}
          onClick={trackClick}
        >
          {t("application_tracking_widget.create_account")}
        </Button>
      </div>
    </div>
  );
};

export default ApplicationTrackingWidget;
